var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"player"},[_c('header',[_vm._v(_vm._s(_vm.deviceName))]),_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }